import { oz } from '@weft/utils';
import { CustomerSchema } from './customer-schema';

export const MinimalCustomerSchema = CustomerSchema.pick({
  id: true,
  accountId: true,
  externalId: true,
});

export type MinimalCustomer = oz.infer<typeof MinimalCustomerSchema>;

export const MinimalCustomerReaderSchema = oz.array(MinimalCustomerSchema);
export type MinimalCustomerReader = oz.infer<typeof MinimalCustomerReaderSchema>;